import Bugsnag from '@bugsnag/expo';
Bugsnag.start();
import 'react-native-gesture-handler';
import React, { useState, Suspense, useEffect } from 'react';
import { Platform, ActivityIndicator } from 'react-native';
import { Color, CommonStyles } from './styles';
import * as SplashScreen from 'expo-splash-screen';
import * as Font from 'expo-font';
import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import immutableCheckMiddleWare from 'redux-immutable-state-invariant';
import { AppNavigator } from './navigators/AppNavigator';
import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import './i18n.js';
import './utils/sentry';
//import bugsnagclient from './utils/bugsnag.native';
const ErrorBoundary = Bugsnag && Bugsnag.getPlugin('react');

import Modal from './components/Modal';

// eslint-disable-next-line no-constant-condition
if (__DEV__ && false) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}
import authReducer from './store/reducers/auth';
import alertReducer from './store/reducers/alert';
import searchReducer from './store/reducers/search';
import airReducer from './store/reducers/air';
import hotelReducer from './store/reducers/hotel';
import carReducer from './store/reducers/car';
import railReducer from './store/reducers/rail';
import seatReducer from './store/reducers/seat';
import myTripsReducer from './store/reducers/mytrips';
import paymentReducer from './store/reducers/payment';
import profileReducer from './store/reducers/profile';
import expenseReducer from './store/reducers/expense';
import eventsReducer from './store/reducers/events';

const allReducers = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  air: airReducer,
  search: searchReducer,
  hotel: hotelReducer,
  car: carReducer,
  rail: railReducer,
  myTrips: myTripsReducer,
  payment: paymentReducer,
  seat: seatReducer,
  profile: profileReducer,
  expense: expenseReducer,
  events: eventsReducer,
});

let middleWares = [ReduxThunk];
const devOnlyMiddleWares = [immutableCheckMiddleWare()];
if (__DEV__) {
  console.log('Development: ON');
  middleWares = [...middleWares, ...devOnlyMiddleWares];
  global.REACT_NAVIGATION_REDUX_DEVTOOLS_EXTENSION_INTEGRATION_ENABLED = true;
}

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return allReducers(state, action);
};

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleWares)));
import { enableScreens } from 'react-native-screens';

if (Platform.OS === 'native') {
  enableScreens();
}

const fetchFonts = () => {
  return Promise.all([
    Font.loadAsync({
      poppins: require('./assets/fonts/Poppins-Regular.ttf'),
    }),
    Font.loadAsync({
      poppinsItalic: require('./assets/fonts/Poppins-Italic.ttf'),
    }),
    Font.loadAsync({
      tripeasy: require('./assets/fonts/tripeasy.ttf'),
    }),
    Font.loadAsync({
      ITCAvantGardeBook: require('./assets/fonts/ITC-Avant-Garde-Gothic-Book-Regular.otf'),
    }),
  ]);
};

// Keep the splash screen visible while we fetch resources
SplashScreen.preventAutoHideAsync();

export default function App() {
  if (Platform.OS === 'web') {
    Modal.setAppElement('#root');
  }
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    async function prepare() {
      try {
        await fetchFonts();
        await SplashScreen.hideAsync();
      } catch (e) {
        console.warn(e);
      } finally {
        // Tell the application to render
        setFontLoaded(true);
      }
    }

    prepare();
  }, []);

  if (!fontLoaded) {
    return (
      <ActivityIndicator
        size="large"
        style={[CommonStyles.flex1, CommonStyles.centerAlignment]}
        color={Color.primary}
      />
    );
  }

  const appRoot =
    Platform.OS === 'web' ? (
      <ActionSheetProvider>
        <Provider store={store}>
          <AppNavigator />
        </Provider>
      </ActionSheetProvider>
    ) : (
      <ErrorBoundary>
        <ActionSheetProvider>
          <Provider store={store}>
            <AppNavigator />
          </Provider>
        </ActionSheetProvider>
      </ErrorBoundary>
    );

  return (
    <Suspense
      fallback={
        <ActivityIndicator
          size="large"
          style={[CommonStyles.flex1, CommonStyles.centerAlignment]}
          color={Color.primary}
        />
      }
    >
      {appRoot}
    </Suspense>
  );
}
